import { render, staticRenderFns } from "./historyPage.vue?vue&type=template&id=d8f6fbb0&scoped=true"
import script from "./historyPage.vue?vue&type=script&lang=js"
export * from "./historyPage.vue?vue&type=script&lang=js"
import style0 from "./historyPage.vue?vue&type=style&index=0&id=d8f6fbb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f6fbb0",
  null
  
)

export default component.exports